import React from 'react';
import PropTypes from 'prop-types';
import ExpandMore from '@material-ui/icons/ExpandMore';
import styles from './CollapsibleEditorSection.module.scss';

const CollapsibleEditorSection = ({
  title,
  subtitle,
  meta,
  isOpen,
  onToggle,
  children,
  testId,
  tone,
  compact,
}) => (
  <section
    className={`${styles.section} ${styles[`tone${tone[0].toUpperCase()}${tone.slice(1)}`] || ''} ${compact ? styles.compact : ''}`.trim()}
    data-testid={testId}
  >
    <button
      type="button"
      onClick={onToggle}
      className={styles.headerButton}
      aria-expanded={isOpen}
      aria-label={title}
    >
      <div className={styles.heading}>
        <div className={styles.titleRow}>
          <span className={styles.title}>{title}</span>
        </div>
        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
      </div>
      <div className={styles.headerAside}>
        {meta && <span className={styles.meta}>{meta}</span>}
        <ExpandMore
          className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`.trim()}
          aria-hidden="true"
        />
      </div>
    </button>
    <div
      className={`${styles.bodyShell} ${isOpen ? styles.bodyShellOpen : ''}`.trim()}
      aria-hidden={!isOpen}
    >
      <div className={styles.bodyClip}>
        <div className={styles.body}>{children}</div>
      </div>
    </div>
  </section>
);

CollapsibleEditorSection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  meta: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  testId: PropTypes.string.isRequired,
  tone: PropTypes.oneOf(['products', 'categories', 'queries', 'suggestions']),
  compact: PropTypes.bool,
};

CollapsibleEditorSection.defaultProps = {
  subtitle: null,
  meta: null,
  tone: 'products',
  compact: false,
};

export default CollapsibleEditorSection;
